import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sent-to-ipx',
  templateUrl: './sent-to-britecore.component.html',
  styleUrls: ['./sent-to-britecore.component.scss']
})
export class SentToBritecoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
